<template>
	<div class="textarea">
		<label v-if="label" :for="name"
			><div class="heading-5">{{ label }}</div></label
		>
		<textarea
			:id="name"
			ref="customTextarea"
			:placeholder="placeholder"
			:value="value"
			:maxlength="maxLength"
			:name="name"
			:disabled="disabled"
			@input="onInput"
			@blur="onInputBlur"
		>
		</textarea>
		<div v-if="isLegend" class="heading-5 char-counter">
			{{ currentValue.length }}/{{ maxLength }}
		</div>
	</div>
</template>
<script>
export default {
	props: {
		placeholder: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			default: ''
		},
		maxLength: {
			type: Number,
			default: 50
		},
		label: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		isLegend: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			currentValue: this.value
		};
	},
	methods: {
		onInput(event) {
			this.currentValue = event.target.value;
			this.$emit('input', this.$refs['customTextarea'].value);
		},
		onInputBlur() {
			this.$emit('blur');
		}
	}
};
</script>
<style lang="scss" scoped>
.textarea {
	label {
		display: block;
		margin-bottom: 4px;

		.heading-5 {
			color: $font-dark;
		}
	}

	textarea {
		font-family: 'RobotoRegular';
		height: 180px;
		width: 100%;
		border: 1px solid $container-border;
		border-radius: 4px;
		outline: none;
		padding: 16px;
		resize: none;
		font-size: 15px;
		line-height: 23px;
		letter-spacing: 0.5px;

		@media (min-width: $breakpoint-mid) {
			font-size: 18px;
			line-height: 27px;
		}

		&:focus {
			border-color: $hover-state;
		}
	}
}

.char-counter {
	position: relative;
	bottom: 30px;
	right: 10px;
	font-size: 12px;
	color: $disabled-text-color;
	text-align: end;
}
</style>
